import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronRight, Monitor, Cpu, Zap, Layers, GitBranch, Globe, Mail } from 'lucide-react';
import { portfolioData } from '../data/mock';

const sectionIcons = {
  hero: Monitor,
  brand: Layers,
  aiera: Cpu,
  work: Zap,
  capabilities: GitBranch,
  systems: Globe,
  contact: Mail
};

const Navigation = ({ activeSection }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', href: 'hero' },
    { name: 'Philosophy', href: 'brand' },
    { name: 'AI Era', href: 'aiera' },
    { name: 'Impact', href: 'work' },
    { name: 'Capabilities', href: 'capabilities' },
    { name: 'Projects', href: 'projects' },
    { name: 'Timeline', href: 'timeline' },
    { name: 'Contact', href: 'contact' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0a0a0f]/80 backdrop-blur-2xl shadow-lg shadow-indigo-500/5' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <button onClick={() => scrollToSection('hero')} className="flex items-center space-x-3">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white text-xs font-bold">
                RS
              </div>
              <span className="text-sm text-gray-400 font-mono hidden sm:block">// application-engineer</span>
            </button>

            <div className="hidden md:flex items-center space-x-1">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className={`relative px-3 py-2 text-xs font-medium rounded-lg transition-all duration-300 ${
                    activeSection === item.href
                      ? 'text-white bg-white/5'
                      : 'text-gray-500 hover:text-gray-300 hover:bg-white/5'
                  }`}
                >
                  {item.name}
                  {activeSection === item.href && (
                    <span className="absolute -bottom-px left-2 right-2 h-px bg-gradient-to-r from-indigo-500 to-cyan-500 rounded-full" />
                  )}
                </button>
              ))}
            </div>

            <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-gray-400 hover:text-white transition-colors">
              {isOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </nav>

      <div className={`fixed inset-0 bg-[#0a0a0f]/98 backdrop-blur-2xl z-40 transition-all duration-500 md:hidden ${
        isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}>
        <div className="flex flex-col items-center justify-center h-full space-y-6 px-8">
          {navItems.map((item, index) => (
            <button
              key={item.name}
              onClick={() => scrollToSection(item.href)}
              className="group text-lg sm:text-xl text-gray-500 hover:text-white transition-all duration-300"
              style={{ transitionDelay: isOpen ? `${index * 80}ms` : '0ms' }}
            >
              <div className="flex items-center space-x-3">
                <ChevronRight size={16} className="opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-indigo-400" />
                <span className={activeSection === item.href ? 'gradient-text font-semibold' : ''}>{item.name}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navigation;
